export default __webpack_public_path__ + "static/media/planner.2006170b.svg";